'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.loadContent = loadContent;
exports.updateContent = updateContent;
exports.updateContenWithWordToContent = updateContenWithWordToContent;
exports.removeContent = removeContent;
exports.loadWithOtherContentIds = loadWithOtherContentIds;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'CONTENT/CONTENT/LOAD';
var SUCCESS = 'CONTENT/CONTENT/SUCCESS';
var FAIL = 'CONTENT/CONTENT/FAIL';

var initialState = {
  loaded: false,
  data: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        data: action.result
      });
    case FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: {},
        error: action.error
      });
    case "CONTENT_LESSON_CONTENTS_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        data: action.result
      });
    default:
      return state;
  }
}

/*
* Actions
* * * * */
function isLoaded(globalState) {
  return globalState.content && globalState.content.loaded;
}

function loadContent(id) {
  // return dispatch =>
  //   dispatch({
  //     types: [LOAD],
  //     promise: ({oneClient}) => oneClient.get('/directions')
  //   })
  console.log('loadContents');
  return {
    types: [LOAD, SUCCESS, FAIL],
    promise: function promise(_ref) {
      var oneApiClient = _ref.oneApiClient;
      return oneApiClient.get('/contents/' + id
      // ,{
      //   params: {
      //     userId,
      //     accessToken
      //   }
      // }
      );
    } //
  };
}

function updateContent(data) {
  // const data = {
  //   id: 0,
  //   name: name,
  //   active: 0,
  //   showCatalog: 0
  // };
  // console.log('loadContents by lesson');
  return {
    types: ["UPDATE_CONTENT_LOAD", "UPDATE_CONTENT_SUCCESS", "UPDATE_CONTENT_FAIL"],
    promise: function promise(_ref2) {
      var oneApiClient = _ref2.oneApiClient;
      return oneApiClient.put('/contents', {
        data: data
      });
    } //
  };
}

function updateContenWithWordToContent(data) {
  //update with WordToContent data... 
  // const data = {
  //   lessonId: 71
  // };
  return {
    types: ["UPDATE_CONTENT_LOAD", "UPDATE_CONTENT_SUCCESS", "UPDATE_CONTENT_FAIL"],
    promise: function promise(_ref3) {
      var oneApiClient = _ref3.oneApiClient;
      return oneApiClient.put('/contents/withWordToContent', {
        data: data
      });
    } //
  };
}

function removeContent(id) {
  return {
    types: ["REMOVE_CONTENT_LOAD", "REMOVE_CONTENT_SUCCESS", "REMOVE_CONTENT_FAIL"],
    promise: function promise(_ref4) {
      var oneApiClient = _ref4.oneApiClient;
      return oneApiClient.del('/Contents/' + id);
    } //
  };
}

function loadWithOtherContentIds(id) {
  var mFilter = {
    where: {
      id: id
    },
    include: {
      relation: 'lesson',
      scope: {
        include: [{
          relation: 'contents',
          scope: {
            fields: {
              id: true,
              position: true,
              name: true
            },
            order: 'position asc'
          }
        }]
      }
    }

  };
  return {
    types: ["CONTENT_LESSON_CONTENTS_LOAD", "CONTENT_LESSON_CONTENTS_SUCCESS", "CONTENT_LESSON_CONTENTS_FAIL"],
    promise: function promise(_ref5) {
      var oneApiClient = _ref5.oneApiClient;
      return oneApiClient.get('/contents/findOne', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/content.js
// module id = 253
// module chunks = 0